const planStatusList = [
  { value: "PAYMENT_CONFIRMED", label: "Pagamento confirmado" },
  { value: "PENDING_PAYMENT", label: "Pagamento pendente" },
];

export default planStatusList;
